import { __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import Modal from '@mui/material/Modal';
import { classNames } from '../../../../utils/common/styling.js';
import { styles } from './DesktopModal.styles.js';

var DesktopModal = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, onClose = _a.onClose, classes = _a.classes, overrideClasses = _a.overrideClasses, keepMounted = _a.keepMounted, disableAutoFocus = _a.disableAutoFocus;
    var rootClass = (classes || {}).root;
    return (React.createElement(Modal, { open: isOpen !== null && isOpen !== void 0 ? isOpen : false, 
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        onClose: onClose, classes: __assign({ root: classNames(styles.root, rootClass) }, overrideClasses), keepMounted: keepMounted, disableAutoFocus: disableAutoFocus }, children));
};

export { DesktopModal as default };
//# sourceMappingURL=DesktopModal.js.map
